<div class="w-100 d-flex justify-content-between py-15px">
  <div class="fs-20px lh-20px d-flex align-items-center font-weight-500">
    {{ header }}
  </div>
  <div
    class="fs-25px lh-20px cursor-pointer pr-15px"
    (click)="bsModalRef.hide()"
  >
    &times;
  </div>
</div>
